export enum reportFolioDetailMenuType {
    EDIT = '1',
    REASSIGN_AREA_DEPARTMENT = '2',
    REASIGN_USER = '3',
    CANCEL = '4',
    RESEND_REPORT = '5',
    REASSING_PROVIDER = '6',
    SEE_REPORT = '7'
}